import { selector } from "recoil";
import { modalState } from "../atoms/modalStatus";

const addModalState = selector({
  key: "addModalState",
  get: ({ get }) => {
    const state = get(modalState);
    return state.addModal;
  },
  set: ({ set, get }, newValue = false) => {
    const state = get(modalState);
    const val = newValue as boolean;
    set(modalState, { ...state, addModal: val });
  },
});

export { addModalState };
